<template>
  <div class="sky-step-view-env-confirm">
    <div class="sky-step-view-env-confirm-content">
      <div class="env-confirm-group">
        <div class="confirm-group-title">
          <div class="confirm-group-title-icon"></div>
          <div class="confirm-group-title-value">软件&外设</div>
          <div class="confirm-group-title-tip">
            展示客户环境的采集外设、软件等详细信息，默认选中代表输出测试方案进行验证，也可取消选择
            <font color="red">
              （兼容为“未知”：可等>=10工作日，需提到
              <span class="sk-link--normal" @click="openCloudKnow()">云智助手</span>
              后等结果；时间紧迫的需自验证）
            </font>
          </div>
        </div>
        <div class="confirm-group-content">
          <div class="confirm-env-item">
            <div class="confirm-env-item-title">
              <div @click="showTipsQuestion('peripheral', '外设')">外设：<i class="el-icon-question"></i></div>
            </div>
            <div class="confirm-env-item-content">
              <div class="confirm-env-item-table software-table">
                <el-table
                  v-loading="loading"
                  ref="peripheral_rl_poc"
                  class="table-content-rl-ter"
                  :data="peripheralList"
                  @select-all="selectPeripheralAll"
                  @select="selectPeripheral"
                  :show-header="true"
                  border
                >
                  <el-table-column type="selection" width="55"> </el-table-column>
                  <el-table-column label="名称" prop="name">
                    <template slot-scope="scope">
                      <div class="wsp-display-flex">
                        <div>{{ scope.row.name }}</div>
                        <el-tooltip
                          v-if="scope.row.sourceFrom === 'MANUALLY_ADD'"
                          class="item"
                          effect="dark"
                          :content="`点击移除当前添加的外设【${scope.row.name}】`"
                          placement="right"
                        >
                          <div
                            class="el-icon-error wsp-padding-left-5 wsp-line-height-24"
                            @click="removePeripheral(scope.row, scope.$index)"
                          ></div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="兼容情况" prop="compat">
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.compat.length === 0"
                        @click="showCompatibleFuzzyPeripheralInfo(scope.row, scope.$index)"
                      >
                        <el-tag type="warning">未知</el-tag>
                        <span v-if="scope.row.fuzzySpecPeripheralList && scope.row.fuzzySpecPeripheralList.length > 0">
                          可能是
                        </span>
                        <span
                          v-if="scope.row.fuzzySpecPeripheralList && scope.row.fuzzySpecPeripheralList.length > 0"
                          class="sk-link--normal"
                          :key="scope.$index"
                        >
                          {{ scope.row.fuzzySpecPeripheralList[0].name }}
                        </span>
                      </div>
                      <div v-else>
                        <el-tag
                          @click="showCompatiblePeripheralInfo(scope.row)"
                          :type="`${dictionary['compatibleStatus'][scope.row.compat[0].compatibleStatus]['type']}`"
                        >
                          {{ dictionary['compatibleStatus'][scope.row.compat[0].compatibleStatus]['label'] }}
                        </el-tag>
                        <span>{{ scope.row.compat[0].productVersion }}及以上</span>
                        <el-tooltip
                          class="item"
                          v-if="
                            scope.row.compat[0].compatibleStatus !== 'SUPPORT' &&
                              scope.row.compat[0].compatibleDesc &&
                              scope.row.compat[0].compatibleDesc !== ''
                          "
                          effect="dark"
                          :content="scope.row.compat[0].compatibleDesc"
                          placement="top-start"
                        >
                          <div class="el-icon-warning bg-red"></div>
                        </el-tooltip>
                        <span
                          v-if="scope.row.hasFuzzyData"
                          class="el-icon-error wsp-padding-left-5 wsp-line-height-24"
                          @click="removeFuzzyPeripheralInfo(scope.row, scope.$index)"
                        ></span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="兼容性案例" prop="fuzzyCollectCompatibleList" width="115">
                    <template slot-scope="scope">
                      <div>
                        <span
                          class="sk-link--normal"
                          v-if="
                            scope.row.fuzzyCollectCompatibleList && scope.row.fuzzyCollectCompatibleList.length >= 0
                          "
                          @click="showFuzzyCollectCompatible(scope.row, 'peripheral')"
                        >
                          数量：{{ scope.row.fuzzyCollectCompatibleList.length }}
                        </span>
                        <span v-else>
                          无案例
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="设备类型" prop="typeCN" width="175"></el-table-column>
                  <el-table-column label="接口" prop="interfaceType" width="95"></el-table-column>
                  <el-table-column label="场景" prop="hasCompatible" width="210">
                    <template slot-scope="scope">
                      <span>{{ sceneMap[scope.row.sceneId].sceneName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="来源" prop="sourceFrom" show-overflow-tooltip width="115">
                    <template slot-scope="scope">
                      <el-tag type="danger" v-if="scope.row.sourceFrom === 'MANUALLY_ADD'">手工添加</el-tag>
                      <el-tag type="success" v-else-if="scope.row.sourceFrom === 'SCENE'">场景推荐</el-tag>
                      <el-tag type="primary" v-else-if="scope.row.sourceFrom === 'CUSTOMER_ENV'">客户环境</el-tag>
                      <el-tag v-else>无</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="confirm-env-item-toolbar">
                <div class="toolbar-title">
                  <span style="margin-left: -8px;"
                    ><el-checkbox
                      v-model="peripheralAllChecked"
                      :indeterminate="peripheralNotAllChecked"
                      @change="handleCheckAllPeripheral"
                      >全选</el-checkbox
                    ></span
                  >
                  共<span class="bg-3bb113 wsp-padding-left-5 wsp-padding-right-3">{{ peripheralList.length }}</span
                  >款外设,已选择<span class="bg-red wsp-padding-left-5 wsp-padding-right-3">{{
                    selectPeripheralCont
                  }}</span
                  >款外设
                </div>
                <div class="toolbar-title bg-red el-icon-warning">手工添加的外设支持删除</div>
                <div class="toolbar-btn">
                  <div class="handel-btn sk-link--normal" @click="addEnvItem('Peripheral')">
                    <i class="el-icon-plus"></i>添加系统外设
                  </div>
                  <!-- <div class="handel-btn sk-link--normal" @click="addEnvItem('HandelPeripheral')">
                    <i class="el-icon-plus"></i>手工添加外设
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="confirm-env-item">
            <div class="confirm-env-item-title">
              <div @click="showTipsQuestion('software', '软件')">软件：<i class="el-icon-question"></i></div>
            </div>
            <div class="confirm-env-item-content">
              <div class="wsp-padding-tb-6 " v-if="envData.blackSoftwareCont > 0">
                当前采集的软件总共有<span class="sk-color--success wsp-padding-lr-3">{{
                  envData.collectSoftwareCont
                }}</span
                >款软件,当前显示<span class="sk-color--info wsp-padding-lr-3">{{ softwareList.length }}</span
                >款软件，其中<span class="sk-color--danger wsp-padding-lr-3">{{ envData.blackSoftwareCont }}</span
                >款软件属于黑名单，若要进行测试或查看，请点击下方添加黑名单软件
              </div>
              <div class="confirm-env-item-table software-table">
                <el-table
                  v-loading="loading"
                  ref="software_rl_poc"
                  class="table-content-rl-ter"
                  :data="softwareList"
                  @select-all="selectSoftwareAll"
                  @select="selectSoftware"
                  :show-header="true"
                  border
                >
                  <el-table-column type="selection" width="55"> </el-table-column>
                  <el-table-column label="名称" prop="name" width="255">
                    <template slot-scope="scope">
                      <div class="wsp-display-flex">
                        <div>{{ scope.row.softwareName }}</div>
                        <el-tooltip
                          v-if="scope.row.sourceFrom === 'MANUALLY_ADD' || scope.row.hasBlack"
                          class="item"
                          effect="dark"
                          :content="`点击移除当前添加的软件【${scope.row.softwareName}】`"
                          placement="right"
                        >
                          <div
                            class="el-icon-error wsp-padding-left-5 wsp-line-height-24"
                            @click="removeSoftware(scope.row, scope.$index)"
                          ></div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="兼容情况" prop="compat">
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.compat.length === 0"
                        @click="showCompatibleFuzzySoftwareInfo(scope.row, scope.$index)"
                      >
                        <el-tag type="warning">未知</el-tag>
                        <span v-if="scope.row.fuzzySpecSoftwareList && scope.row.fuzzySpecSoftwareList.length > 0">
                          可能是
                        </span>
                        <span
                          v-if="scope.row.fuzzySpecSoftwareList && scope.row.fuzzySpecSoftwareList.length > 0"
                          class="sk-link--normal"
                          :key="scope.$index"
                        >
                          {{ scope.row.fuzzySpecSoftwareList[0].softwareName }}
                        </span>
                      </div>
                      <div v-else>
                        <el-tag
                          @click="showCompatibleSoftwareInfo(scope.row)"
                          :type="`${dictionary['compatibleStatus'][scope.row.compat[0].compatibleStatus]['type']}`"
                        >
                          {{ dictionary['compatibleStatus'][scope.row.compat[0].compatibleStatus]['label'] }}
                        </el-tag>
                        <span @click="showCompatibleSoftwareInfo(scope.row)"
                          >{{ scope.row.compat[0].productVersion }}及以上</span
                        >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          v-if="
                            scope.row.compat[0].compatibleStatus !== 'SUPPORT' &&
                              scope.row.compat[0].compatibleDesc &&
                              scope.row.compat[0].compatibleDesc !== ''
                          "
                          :content="scope.row.compat[0].compatibleDesc"
                          placement="top-start"
                        >
                          <span class="el-icon-warning bg-red"></span>
                        </el-tooltip>
                        <span
                          v-if="scope.row.hasFuzzyData"
                          class="el-icon-error wsp-padding-left-5 wsp-line-height-24"
                          @click="removeFuzzySoftwareInfo(scope.row, scope.$index)"
                        ></span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="兼容性案例" prop="fuzzyCollectCompatibleList" width="115">
                    <template slot-scope="scope">
                      <div>
                        <span
                          class="sk-link--normal"
                          v-if="
                            scope.row.fuzzyCollectCompatibleList && scope.row.fuzzyCollectCompatibleList.length >= 0
                          "
                          @click="showFuzzyCollectCompatible(scope.row, 'software')"
                        >
                          数量：{{ scope.row.fuzzyCollectCompatibleList.length }}
                        </span>
                        <span v-else>
                          无案例
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="版本" prop="softwareVersion" width="175"></el-table-column>
                  <el-table-column label="场景" prop="hasCompatible" width="210">
                    <template slot-scope="scope">
                      <span>{{ sceneMap[scope.row.sceneId].sceneName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="来源" prop="sourceFrom" show-overflow-tooltip width="115">
                    <template slot-scope="scope">
                      <el-tag type="danger" v-if="scope.row.sourceFrom === 'MANUALLY_ADD'">手工添加</el-tag>
                      <el-tag type="success" v-else-if="scope.row.sourceFrom === 'SCENE'">场景推荐</el-tag>
                      <el-tag type="primary" v-else-if="scope.row.sourceFrom === 'CUSTOMER_ENV'">客户环境</el-tag>
                      <el-tag v-else>无</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="confirm-env-item-toolbar">
                <div class="toolbar-title">
                  <span style="margin-left: -8px;"
                    ><el-checkbox
                      v-model="softwareAllChecked"
                      :indeterminate="softwareNotAllChecked"
                      @change="handleCheckAllSoftware"
                      >全选</el-checkbox
                    ></span
                  >
                  共<span class="bg-3bb113 wsp-padding-left-5 wsp-padding-right-3">{{ softwareList.length }}</span
                  >款软件,已选择<span class="bg-red wsp-padding-left-5 wsp-padding-right-3">{{
                    selectSoftwareCont
                  }}</span
                  >款软件
                </div>
                <div class="toolbar-title bg-red el-icon-warning">手工添加的软件支持删除</div>
                <div class="toolbar-btn">
                  <div class="handel-btn sk-link--normal" @click="addEnvItem('Software')">
                    <i class="el-icon-plus"></i>添加系统软件
                  </div>
                  <!-- <div class="handel-btn sk-link--normal" @click="addEnvItem('HandelSoftware')">
                    <i class="el-icon-plus"></i>手工添加软件
                  </div> -->
                  <div
                    class="handel-btn sk-link--normal"
                    v-if="envData.blackSoftwareCont > 0"
                    @click="addEnvItem('BlackSoftware')"
                  >
                    <i class="el-icon-plus"></i>添加黑名单软件
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="env-confirm-group">
        <div class="confirm-group-title">
          <div class="confirm-group-title-icon"></div>
          <div class="confirm-group-title-value">硬件确认</div>
          <div class="confirm-group-title-tip">
            展示包括客户环境的采集及通过添加新终端选择的终端信息，选中代表输出测试方案进行验证
          </div>
          <span></span>
        </div>
        <div class="confirm-group-content">
          <div class="confirm-env-item">
            <div class="confirm-env-item-title">
              <div @click="showTipsQuestion('terminal', '终端')">终端：<i class="el-icon-question"></i></div>
            </div>
            <div class="confirm-env-item-content">
              <div class="confirm-env-item-table">
                <el-table
                  v-loading="loading"
                  ref="terminal_rl_poc"
                  class="table-content-rl-ter"
                  :data="terminalList"
                  @select-all="handleSelectionAllChange"
                  @select="selectTerminal"
                  :show-header="true"
                  border
                >
                  <el-table-column type="selection" width="55" />
                  <el-table-column :label="$t('pocMng.client.version')" prop="model" show-overflow-tooltip width="210">
                    <template slot-scope="scope">
                      <div class="wsp-display-flex">
                        <!-- <div
                          :class="scope.row.sourceFrom === 'SCENE' ? 'wsp-icon-tuijian  bg-f13131 font-size-28' : ''"
                        ></div> -->
                        <div>{{ scope.row.model }}</div>
                        <div v-if="scope.row.hasRecommend === false">
                          <el-tooltip
                            class="box-item"
                            effect="dark"
                            :content="scope.row.notRecommendDesc"
                            placement="right"
                          >
                            <div class="el-icon-warning bg-red" style="padding-left: 5px;"></div>
                          </el-tooltip>
                        </div>
                        <el-tooltip
                          class="item"
                          v-if="scope.row.remarks && scope.row.remarks !== ''"
                          effect="dark"
                          :content="scope.row.remarks"
                          placement="top-start"
                        >
                          <div class="el-icon-warning bg-red wsp-padding-left-5 wsp-line-height-24"></div>
                        </el-tooltip>
                        <el-tooltip
                          v-if="scope.row.sourceFrom === 'MANUALLY_ADD'"
                          class="item"
                          effect="dark"
                          :content="`点击移除当前添加的终端【${scope.row.model}】`"
                          placement="right"
                        >
                          <div
                            class="el-icon-error wsp-padding-left-5 wsp-line-height-24"
                            @click="removeTerminal(scope.row, scope.$index)"
                          ></div>
                        </el-tooltip>
                      </div> </template
                  ></el-table-column>
                  <el-table-column
                    width="100"
                    :label="$t('pocMng.client.type')"
                    prop="typeDesc"
                    :align="'left'"
                    show-overflow-tooltip
                  />
                  <el-table-column :label="$t('pocMng.client.cpu')" prop="cpuInfo" show-overflow-tooltip />
                  <el-table-column
                    :label="$t('pocMng.client.memory')"
                    prop="memoryInfo"
                    width="110"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    :label="$t('pocMng.client.disk')"
                    prop="diskInfo"
                    width="110"
                    show-overflow-tooltip
                  />
                  <el-table-column label="场景" prop="sourceFrom" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.sceneId">{{ sceneMap[scope.row.sceneId].sceneName }}</span>
                      <span v-else>无</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="来源" prop="sourceFrom" show-overflow-tooltip width="115">
                    <template slot-scope="scope">
                      <el-tag type="danger" v-if="scope.row.sourceFrom === 'MANUALLY_ADD'">手工添加</el-tag>
                      <el-tag type="success" v-else-if="scope.row.sourceFrom === 'SCENE'">场景推荐</el-tag>
                      <el-tag type="primary" v-else-if="scope.row.sourceFrom === 'CUSTOMER_ENV'">客户环境</el-tag>
                      <el-tag v-else>无</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="confirm-env-item-toolbar">
                <div class="toolbar-title">
                  共<span class="bg-3bb113 wsp-padding-left-5 wsp-padding-right-3">{{ terminalList.length }}</span
                  >类型终端,已选择<span class="bg-red wsp-padding-left-5 wsp-padding-right-3">{{
                    selectTerminalCont
                  }}</span
                  >类型终端
                </div>
                <div class="toolbar-title bg-red el-icon-warning">手工添加的终端支持删除</div>
                <div class="toolbar-btn">
                  <div class="handel-btn sk-link--normal" @click="addEnvItem('Terminal')">
                    <i class="el-icon-plus"></i>添加自研终端
                  </div>
                  <div class="handel-btn sk-link--normal" @click="addEnvItem('ThrideTerminal')">
                    <i class="el-icon-plus"></i>添加第三方终端
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="confirm-env-item">
            <div class="confirm-env-item-title">
              <div @click="showTipsQuestion('server', '服务器')">服务器：<i class="el-icon-question"></i></div>
            </div>
            <div class="confirm-env-item-content">
              <div class="confirm-env-item-table">
                <el-table
                  ref="scene_rl_server"
                  class=" table_server table-content-spec"
                  :data="serverList"
                  highlight-current-row
                  @select-all="selectAllServer"
                  @select="selectServer"
                  :show-header="true"
                  :key="reloadTable"
                  border
                >
                  <el-table-column type="selection" width="55" :selectable="selectable"> </el-table-column>
                  <el-table-column
                    :label="$t('pocMng.server.serverName')"
                    prop="serverName"
                    show-overflow-tooltip
                    width="240"
                  >
                    <template slot-scope="scope">
                      <div class="wsp-display-flex">
                        <div>{{ scope.row.serverName }}</div>
                        <div v-if="scope.row.hasRecommend === false">
                          <el-tooltip
                            class="box-item"
                            effect="dark"
                            :content="scope.row.notRecommendDesc"
                            placement="right"
                          >
                            <div class="el-icon-warning bg-red" style="padding-left: 5px;"></div>
                          </el-tooltip>
                        </div>
                        <el-tooltip
                          v-if="scope.row.sourceFrom === 'MANUALLY_ADD'"
                          class="item"
                          effect="dark"
                          :content="`点击移除当前添加的服务器【${scope.row.serverName}】`"
                          placement="right"
                        >
                          <div
                            class="el-icon-error wsp-padding-left-5 wsp-line-height-24"
                            @click="removeServer(scope.row, scope.$index)"
                          ></div>
                        </el-tooltip>
                        <el-tooltip
                          v-if="
                            !['IDV', 'VDI', 'MINI'].includes(scope.row.type) &&
                              scope.row.sourceFrom === 'MANUALLY_ADD' &&
                              scope.row.serverName != '无需服务器'
                          "
                          class="item"
                          effect="dark"
                          :content="`点击查看兼容结果`"
                          placement="right"
                        >
                          <div
                            class="sk-icon-eye wsp-padding-left-5 wsp-line-height-24"
                            style="cursor: pointer;"
                            @click="showImg(scope.row)"
                          ></div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column :label="$t('pocMng.server.cpu')" prop="cpuInfo" show-overflow-tooltip /> -->

                  <el-table-column
                    :label="$t('pocMng.server.cpu')"
                    width="240"
                    prop="cpuConfigId"
                    class-name="full-value-content"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-select
                        style="width: 100%;"
                        v-if="scope.row.sourceType !== 'ThrideServer'"
                        v-model="scope.row.cpuConfigId"
                        first
                        class="full-content"
                        @change="changeCpu"
                      >
                        <el-option
                          v-for="item in scope.row.specServerConfigDTOList"
                          :key="item.id"
                          :label="item.configValueOne"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <div v-else>{{ scope.row.cpu }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="GPU"
                    width="140"
                    prop="gpuConfigId"
                    class-name="full-value-content"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-select
                        style="width: 100%;"
                        v-if="scope.row.sourceType !== 'ThrideServer' && scope.row.gpuConfigDTOList"
                        v-model="scope.row.gpuConfigId"
                        first
                        class="full-content"
                        @change="changeGpu"
                      >
                        <el-option
                          v-for="item in scope.row.gpuConfigDTOList"
                          :key="item.id"
                          :label="`${item.configValueOne} ${item.configValueTwo}`"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <div v-else>{{ scope.row.gpu }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" width="125" prop="serverCount" class-name="full-value-content">
                    <template slot-scope="scope">
                      <el-input-number
                        v-if="scope.row.serverName != '无需服务器'"
                        v-model="scope.row.serverCount"
                        :min="1"
                        :max="20"
                        style="width:120px"
                        @change="validateDataChange"
                      ></el-input-number>
                      <el-input-number
                        v-if="scope.row.serverName == '无需服务器'"
                        v-model="scope.row.serverCount"
                        :min="0"
                        :max="0"
                        style="width:120px"
                        :disabled="true"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="服务器类型" prop="type" show-overflow-tooltip width="140">
                    <template slot-scope="scope">
                      <div v-if="scope.row.type === 'VDI'">三擎服务器</div>
                      <div v-else-if="scope.row.type === 'IDV'">纯TCI/IDV服务器</div>
                      <div v-else-if="scope.row.type === 'MINI'">MINI服务器</div>
                      <div v-else>第三方服务器</div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('pocMng.server.memory')" prop="memoryInfo" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-show="!scope.row.compatibleResultImg">{{ scope.row.memoryInfo }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('pocMng.server.diskInfo')" prop="diskInfo" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-show="!scope.row.compatibleResultImg">{{ scope.row.diskInfo }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="场景" prop="sceneName" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.sceneId">{{ sceneMap[scope.row.sceneId].sceneName }}</span>
                      <span v-else>无</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="来源" prop="sourceFrom" show-overflow-tooltip width="115">
                    <template slot-scope="scope">
                      <div>
                        <el-tag type="danger" v-if="scope.row.sourceFrom === 'MANUALLY_ADD'">手工添加</el-tag>
                        <el-tag type="success" v-else-if="scope.row.sourceFrom === 'SCENE'">场景推荐</el-tag>
                        <el-tag type="primary" v-else-if="scope.row.sourceFrom === 'CUSTOMER_ENV'">客户环境</el-tag>
                        <el-tag v-else>无</el-tag>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="confirm-env-item-toolbar">
                <div class="toolbar-title ">
                  共<span class="bg-3bb113 wsp-padding-left-5 wsp-padding-right-3">{{ serverList.length }}</span
                  >类型服务器
                </div>
                <div class="toolbar-title ">
                  已选择<span class=" bg-red wsp-padding-left-5 wsp-padding-right-3">{{ selectServerCont }}</span
                  >类型服务器
                </div>
                <div class="toolbar-title bg-red el-icon-warning" v-if="hasVDITerminal">IDV服务器不支持VDI终端接入</div>
                <div class="toolbar-btn">
                  <div class="handel-btn sk-link--normal" @click="addEnvItem('Server')">
                    <i class="el-icon-plus"></i>添加自研服务器
                  </div>
                  <div class="handel-btn sk-link--normal" @click="addEnvItem('ThrideServer')">
                    <i class="el-icon-plus"></i>添加第三方服务器
                  </div>
                  <div class="handel-btn sk-link--normal" @click="selectNoServer()">
                    <i class="el-icon-plus"></i>无需服务器
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="env-confirm-group">
        <div class="confirm-group-title">
          <div class="confirm-group-title-icon"></div>
          <div class="confirm-group-title-value">操作系统</div>
        </div>
        <div class="confirm-group-content">
          <div class="confirm-env-item">
            <div class="confirm-env-item-title" @click="showTipsQuestion('imageOs', '云桌面操作系统')">
              云桌面 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <br />操作系统：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content">
              <el-checkbox-group v-model="imageSystem" @change="validateDataChange">
                <el-row>
                  <el-col v-for="(sysItem, sysIndex) in osType.desktop" :key="sysIndex" :span="4">
                    <el-checkbox :label="sysItem.id" :disabled="!checkSupport(sysItem)">
                      <el-tooltip
                        v-if="!checkSupport(sysItem)"
                        class="item"
                        effect="dark"
                        content="当前测试方案不支持此操作系统"
                        placement="top-start"
                      >
                        <div class="el-icon-warning bg-red wsp-padding-left-5 wsp-line-height-24"></div>
                      </el-tooltip>
                      {{ sysItem.osType }}</el-checkbox
                    >
                  </el-col>
                </el-row>
              </el-checkbox-group>
              <div class="wsp-padding-tb-12 sk-link--normal" @click="addEnvItem('OsTypeConfig', 'DESKTOP')">
                <i class="el-icon-plus"></i>添加操作系统
              </div>
            </div>
          </div>
          <div class="confirm-env-item">
            <div class="confirm-env-item-title" @click="showTipsQuestion('appOs', '云应用操作系统')">
              云应用 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <br />操作系统：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content">
              <el-checkbox-group v-model="appSystem" @change="validateDataChange">
                <el-row>
                  <el-col v-for="(sysItem, sysIndex) in osType.app" :key="sysIndex" :span="4">
                    <el-checkbox :label="sysItem.id">{{ sysItem.osType }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
              <div class="wsp-padding-tb-12 sk-link--normal" @click="addEnvItem('OsTypeConfig', 'APP')">
                <i class="el-icon-plus"></i>添加操作系统
              </div>
            </div>
          </div>
          <div class="confirm-env-item">
            <div class="confirm-env-item-title" @click="showTipsQuestion('hostOs', '云桌面/云应用宿主机操作系统')">
              云桌面/云应用&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />宿主机 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <br />操作系统：
              <i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content">
              <el-checkbox-group v-model="hostSystem" @change="validateDataChange">
                <el-row>
                  <el-col v-for="(sysItem, sysIndex) in osType.host" :key="sysIndex" :span="4">
                    <el-checkbox :label="sysItem.id">{{ sysItem.osType }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
              <div class="wsp-padding-tb-12 sk-link--normal" @click="addEnvItem('OsTypeConfig', 'HOST')">
                <i class="el-icon-plus"></i>添加操作系统
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="env-confirm-group">
        <div class="confirm-group-title">
          <div class="confirm-group-title-icon"></div>
          <div class="confirm-group-title-value">网络信息确认</div>
        </div>
        <div class="confirm-group-content">
          <div class="confirm-env-item confirm-radio-group">
            <div class="confirm-env-item-title" @click="showTipsQuestion('firewall', '是否有防火墙')">
              有防火墙：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content confirm-radio-group">
              <el-switch v-model="network.hasFirewall" active-text="是" inactive-text="否" @change="validateDataChange">
              </el-switch>
            </div>
          </div>
          <div class="confirm-env-item confirm-radio-group" v-show="false">
            <div class="confirm-env-item-title" @click="showTipsQuestion('ipMacBind', '是否IP+MAC绑定')">
              IP+MAC绑定：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content confirm-radio-group">
              <el-switch
                v-model="network.hasIpMacBind"
                active-text="是"
                inactive-text="否"
                @change="validateDataChange"
              >
              </el-switch>
            </div>
          </div>
          <div class="confirm-env-item confirm-radio-group" v-show="false">
            <div class="confirm-env-item-title" @click="showTipsQuestion('vpn', '是否有VPN')">
              有VPN：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content confirm-radio-group">
              <el-switch v-model="network.hasVpn" active-text="是" inactive-text="否" @change="validateDataChange">
              </el-switch>
            </div>
          </div>
          <div class="confirm-env-item confirm-radio-group">
            <div class="confirm-env-item-title" @click="showTipsQuestion('nat', '是否有NAT')">
              有NAT：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content confirm-radio-group">
              <el-switch v-model="network.hasNat" active-text="是" inactive-text="否" @change="validateDataChange">
              </el-switch>
            </div>
          </div>
          <div class="confirm-env-item confirm-radio-group" v-show="false">
            <div class="confirm-env-item-title" @click="showTipsQuestion('networkSpeed', '网络速度')">
              网络速度：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content confirm-radio-group">
              <el-radio-group v-model="network.networkSpeed" @input="validateDataChange">
                <el-radio v-for="(speed, seIndex) in networkSpeed" :key="seIndex" :label="speed.id">{{
                  speed.label
                }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="confirm-env-item confirm-radio-group" v-show="false">
            <div class="confirm-env-item-title" @click="showTipsQuestion('networkPort', '开启端口')">
              开启端口：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content confirm-radio-group">
              <network-port-tag-custom
                @selectChange="networkPortChange"
                :values="network.networkPortList"
              ></network-port-tag-custom>
            </div>
          </div>
          <div class="confirm-env-item confirm-radio-group">
            <div class="confirm-env-item-title" @click="showTipsQuestion('openPortList', '开放端口列表')">
              开放端口列表：<i class="el-icon-question"></i>
            </div>
            <div class="confirm-env-item-content confirm-radio-group">
              <a href="https://ruijie.feishu.cn/sheets/PtRosyGkthpBIktzRalcEUmenOg" target="_blank">点击查看</a>
            </div>
          </div>
        </div>
      </div>
      <div class="group-buttom"></div>
    </div>

    <el-drawer
      ref="drawer"
      :visible="visable"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="closerDrawer"
      direction="rtl"
    >
      <div style="margin-top: -70px;margin-bottom: 20px;margin-left: 10px;margin-right: 60px;">
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template>
              <span v-if="visableType === 'Software'">选择测试软件</span>
              <span v-else-if="visableType === 'BlackSoftware'">添加黑名单软件</span>
              <span v-else-if="visableType === 'FuzzySoftware'">选择测试软件</span>
              <span v-else-if="visableType === 'Peripheral'">添加外设</span>
              <span v-else-if="visableType === 'Terminal'">添加终端</span>
              <span v-else-if="visableType === 'ThrideTerminal'">添加第三方终端</span>
              <span v-else-if="visableType === 'Server'">添加自有服务器</span>
              <span v-else-if="visableType === 'ThrideServer'">添加第三方服务器</span>
              <span v-else-if="visableType === 'OsTypeConfig'">添加操作系统</span>
              <span v-else>添加</span>
            </template>
          </div>
        </div>
      </div>
      <black-software-table
        v-if="visableType === 'BlackSoftware'"
        @addSelect="addSelect"
        :projectId="projectId"
        :scenes="scenes"
      ></black-software-table>
      <fuzzy-software-table
        v-if="visableType === 'FuzzySoftware'"
        @selectFuzzyItem="selectFuzzySoftwareItem"
        :data="fuzzyItemSoftwareIds"
        :specId="selectFuzzyItemSpecId"
      ></fuzzy-software-table>
      <fuzzy-peripheral-table
        v-if="visableType === 'FuzzyPeripheral'"
        @selectFuzzyItem="selectFuzzyPeripheralItem"
        :data="fuzzyItemPeripheralIds"
        :specId="selectFuzzyItemSpecId"
      ></fuzzy-peripheral-table>
      <software-table v-if="visableType === 'Software'" @addSelect="addSelect" :scenes="scenes"></software-table>
      <peripheral-table v-if="visableType === 'Peripheral'" @addSelect="addSelect" :scenes="scenes"></peripheral-table>
      <server-table v-if="visableType === 'Server'" @addSelect="addSelect" :scenes="scenes"></server-table>
      <terminal-table
        v-if="visableType === 'Terminal'"
        @addSelect="addSelect"
        @cancel="cancelDower"
        :scenes="scenes"
        @unSelect="unSelect"
      ></terminal-table>
      <os-type-config-table
        v-if="visableType === 'OsTypeConfig'"
        :subType="subType"
        :productIds="this.productIds"
        @addSelect="addSelectOs"
        @cancel="cancelDower"
        @unSelect="unSelect"
      ></os-type-config-table>
      <thride-terminal-form
        v-if="visableType === 'ThrideTerminal'"
        @addSelect="addSelect"
        :scenes="scenes"
      ></thride-terminal-form>
      <thride-server-form
        v-if="visableType === 'ThrideServer'"
        @addSelect="addSelect"
        :scenes="scenes"
      ></thride-server-form>
      <div v-if="visableType === 'QUERYTON_TIPS'">
        <div>图标内容</div>
      </div>
    </el-drawer>
    <el-drawer
      ref="drawer"
      :visible="visableTips"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="23%"
      :before-close="closerTipsDrawer"
      direction="rtl"
    >
      <div
        style="margin-top: -70px;margin-bottom: 20px;margin-left: 10px;margin-right: 60px;"
        class="wsp-padding-tb-12"
      >
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template>
              <span>{{ visableTitle }}</span
              ><span>说明</span>
            </template>
          </div>
        </div>
      </div>
      <div class="drawer-tips">
        <div class="tips-rl-question">相关解释</div>
        <div class="drawer-tips-content">{{ lang.t(visableExplanation) }}</div>
        <div class="tips-rl-question">热点问题</div>
        <div class="drawer-tips-content">{{ lang.t(visableQuestion) }}</div>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="dialogVisible" :width="dialogImageUrl ? null : '30%'" append-to-body>
      <img v-if="dialogImageUrl" width="100%" :src="dialogImageUrl" alt />
      <div v-else>
        <div><span style="font-weight: bolder">是否适配：</span>{{ compatibleResult == 'YES' ? '是' : '否' }}</div>
        <div><span style="font-weight: bolder">不适配理由：</span>{{ compatibleMsg }}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Card,
  Button,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  RadioButton,
  InputNumber,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  Option,
  Select,
  Switch,
  Tag,
  Radio,
  Drawer,
  Row,
  Col,
  Popover,
  Dialog
} from 'element-ui'

import RelationOption from 'sky-engine/views/formController/form/relation-option'

import BlackSoftwareTable from './BlackSoftwareTable'
import FuzzyPeripheralTable from './FuzzyPeripheralTable'
import FuzzySoftwareTable from './FuzzySoftwareTable'
import NetworkPortTagCustom from './NetworkPortTagCustom'
import OsTypeConfigTable from './OsTypeConfigTable'
import PeripheralTable from './PeripheralTable'
import ServerTable from './ServerTable'
import SoftwareTable from './softwareTable'
import TerminalTable from './TerminalTable'
import ThrideServerForm from './thrideServerForm'
import ThrideTerminalForm from './thrideTerminalForm'

import dictionary from '../../../../../../utils/dictionary'

import {
  getEnvDetail,
  updateSceneRealtionEnv
  // serverCalculator
} from '@/api/env'
import { getAllOsType } from '@/api/osType'

import { sceneBindDetail } from '@/api/scene'
import { getServerDetail, getServerList } from '@/api/server'
import { getBackupType, getCalculatorScene, getNetworkSpeed } from '@/api/setting'

import { createTestCase } from '@/api/testcase'
import lang from '@/lang'
import { isDeepEqual } from '@/utils/pageUtils'

export default {
  name: 'SkyStepViewEnvConfirm',
  props: {
    projectId: {
      type: String,
      default: null
    }
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Card.name]: Card,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [RelationOption.name]: RelationOption,
    [Drawer.name]: Drawer,
    [RadioButton.name]: RadioButton,
    [InputNumber.name]: InputNumber,
    [Option.name]: Option,
    [Select.name]: Select,
    [Switch.name]: Switch,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Popover.name]: Popover,
    SoftwareTable,
    PeripheralTable,
    ServerTable,
    TerminalTable,
    OsTypeConfigTable,
    ThrideServerForm,
    BlackSoftwareTable,
    FuzzySoftwareTable,
    FuzzyPeripheralTable,
    NetworkPortTagCustom,
    ThrideTerminalForm,
    [Dialog.name]: Dialog
  },
  created() {
    this.$emit('openChangeDialog', { projectId: this.projectId })
    this.$emit('showBtns', {
      preStep: false,
      nextStep: false,
      saveStep: false,
      enableTabChange: true
    })
    this.queryGlobalData().then(res => {
      this.getInitDat()
    })
  },
  mounted() {},
  data: function() {
    return {
      loading: true,
      lang: lang,
      envData: {
        collectSoftwareCont: 0,
        blackSoftwareCont: 0
      },
      dictionary: dictionary,
      osTypeArr: [],
      osTypeMap: {},
      osType: {
        desktop: [],
        host: [],
        app: []
      },
      networkSpeed: [],
      calculatorScene: [],
      calculatorSceneMap: {},
      backupTypeArr: [],
      visable: false,
      visableType: null,
      softwareList: [],
      selectSoftwareCont: 0,
      terminalList: [],
      selectTerminalCont: 0,
      visableTips: false,
      visableExplanation: null,
      visableQuestion: null,
      serverList: [],
      hasVDITerminal: false,
      peripheralList: [],
      selectPeripheralCont: 0,
      thirdServerList: [],
      imageSystem: [],
      appSystem: [],
      hostSystem: [],
      supportImageSystem: [],
      supportAppSystem: [],
      supportHostSystem: [],
      subType: null,
      network: {
        hasFirewall: false,
        hasIpMacBind: false,
        hasVpn: false,
        hasNat: false,
        networkPortList: [],
        networkSpeed: 'THOUSAND_GIGABIT'
      },
      selectServerCont: 0,
      selectCalcServer: {},
      visableTitle: '',
      selectCalcTerminal: [],
      calcSetting: {
        dataDiskMaxSlot: 10,
        backupType: 'FOUR_D_ONE_P',
        oneDisk: 8,
        numCMS: 12,
        hasHighAvailability: true,
        hasDualScreen: true
      },
      sceneMap: {},
      reloadTable: false,
      scenes: [],
      fuzzyItemSoftwareIds: [],
      fuzzyItemPeripheralIds: [],
      fuzzyItemSoftwareIdIndex: null,
      fuzzyItemPeripheralIdIndex: null,
      netwrok: null,
      softwareAllChecked: true,
      softwareNotAllChecked: false,
      peripheralAllChecked: true,
      peripheralNotAllChecked: false,
      haveVDITerminal: false,
      tempData: {},
      oldData: {},
      dialogVisible: false,
      dialogImageUrl: null,
      compatibleResult: null,
      compatibleMsg: null,
      productIds: null
    }
  },
  methods: {
    openCloudKnow() {
      window.open('http://csc.ruijie.com.cn:9205/#/service/maxWidth', '_blank')
    },
    checkSupport(row) {
      return this.supportImageSystem ? this.supportImageSystem.includes(row.id) : true
    },
    changeCpu(val) {
      this.validateDataChange()
    },
    changeGpu(val) {
      this.validateDataChange()
    },
    networkPortChange(portValue) {
      this.network.networkPortList = portValue
      this.validateDataChange()
    },
    showCompatiblePeripheralInfo(rowData) {
      if (rowData.sourceFrom === 'CUSTOMER_ENV') {
        this.$store.dispatch('PeripheralCompatibleProductRelationByName', {
          peripheralName: rowData.name
        })
      } else if (rowData.sourceFrom === 'MANUALLY_ADD') {
        this.$store.dispatch('PeripheralCompatibleProductRelationById', {
          peripheralId: rowData.peripheralId
        })
      }
    },
    removeFuzzySoftwareInfo(row, index) {
      this.$set(this.softwareList[index], 'specSoftwareId', null)
      this.$set(this.softwareList[index], 'hasFuzzyData', false)
      this.$set(this.softwareList[index], 'compat', [])
      this.validateDataChange()
    },
    removeFuzzyPeripheralInfo(row, index) {
      this.$set(this.peripheralList[index], 'specPeripheralId', null)
      this.$set(this.peripheralList[index], 'hasFuzzyData', false)
      this.$set(this.peripheralList[index], 'compat', [])
      this.validateDataChange()
    },
    selectFuzzySoftwareItem(params) {
      this.$set(this.softwareList[this.fuzzyItemSoftwareIdIndex], 'specSoftwareId', params.id)
      this.$set(this.softwareList[this.fuzzyItemSoftwareIdIndex], 'hasOutputTestPlan', false)
      this.$set(this.softwareList[this.fuzzyItemSoftwareIdIndex], 'hasFuzzyData', false)

      const exists = this.softwareList.some(obj => obj.softwareId === params.id && obj.sceneId === params.sceneId)
      if (exists) {
        this.visable = false
        return
      }
      this.softwareList.splice(this.fuzzyItemSoftwareIdIndex, 0, {
        hasMatched: false,
        hasOutputTestPlan: true,
        sceneId: this.softwareList[this.fuzzyItemSoftwareIdIndex].sceneId,
        sceneName: this.sceneMap[this.softwareList[this.fuzzyItemSoftwareIdIndex].sceneId].sceneName,
        softwareId: params.id,
        compat: params.compat,
        hasCompatible: false,
        softwareName: params.softwareName,
        softwareVersion: params.softwareVersion,
        sourceFrom: 'MANUALLY_ADD',
        specSoftwareId: params.id
      })

      this.visable = false
      this.fuzzyItemSoftwareIdIndex = null
      this.visableType = null
      this.reloadSoftwareSelectTable()
      this.validateDataChange()
    },
    selectFuzzyPeripheralItem(params) {
      this.$set(this.peripheralList[this.fuzzyItemPeripheralIdIndex], 'specPeripheralId', params.id)
      this.$set(this.peripheralList[this.fuzzyItemPeripheralIdIndex], 'hasOutputTestPlan', false)
      this.$set(this.peripheralList[this.fuzzyItemPeripheralIdIndex], 'hasFuzzyData', false)

      const exists = this.peripheralList.some(obj => obj.peripheralId === params.id && obj.sceneId === params.sceneId)
      if (exists) {
        this.visable = false
        return
      }
      this.peripheralList.splice(this.fuzzyItemPeripheralIdIndex, 0, {
        hasMatched: false,
        hasOutputTestPlan: true,
        sceneId: this.peripheralList[this.fuzzyItemPeripheralIdIndex].sceneId,
        sceneName: this.sceneMap[this.peripheralList[this.fuzzyItemPeripheralIdIndex].sceneId].sceneName,
        peripheralId: params.id,
        compat: params.compat,
        hasCompatible: false,
        name: params.name,
        type: params.type,
        typeCN: params.typeCN,
        interfaceType: params.interfaceType,
        sourceFrom: 'MANUALLY_ADD',
        specPeripheralId: params.id
      })

      this.visable = false
      this.fuzzyItemPeripheralIdIndex = null
      this.visableType = null
      this.reloadPeripheralSelectTable()
      this.validateDataChange()
    },
    showFuzzyCollectCompatible(rowData, type) {
      this.fuzzyCollectCompatibleIds = []
      if (rowData.fuzzyCollectCompatibleList && rowData.fuzzyCollectCompatibleList.length > 0) {
        for (const iterator of rowData.fuzzyCollectCompatibleList) {
          this.fuzzyCollectCompatibleIds.push(iterator.id)
        }
      }

      let name = type === 'software' ? rowData.softwareName : rowData.name
      var params = {
        fuzzyCollectCompatibleIds: this.fuzzyCollectCompatibleIds,
        compatibleObjName: name
      }
      this.$store.dispatch('showCompatibleRelation', params)
      return
    },
    showCompatibleFuzzySoftwareInfo(rowData, index) {
      this.fuzzyItemSoftwareIds = []
      this.fuzzyItemSoftwareIdIndex = index
      if (rowData.fuzzySpecSoftwareList && rowData.fuzzySpecSoftwareList.length > 0) {
        for (const iterator of rowData.fuzzySpecSoftwareList) {
          this.fuzzyItemSoftwareIds.push(iterator.id)
        }
        this.visable = true
        this.visableType = 'FuzzySoftware'
      }
      return
    },
    showCompatibleFuzzyPeripheralInfo(rowData, index) {
      this.fuzzyItemPeripheralIds = []
      this.fuzzyItemPeripheralIdIndex = index
      if (rowData.fuzzySpecPeripheralList && rowData.fuzzySpecPeripheralList.length > 0) {
        for (const iterator of rowData.fuzzySpecPeripheralList) {
          this.fuzzyItemPeripheralIds.push(iterator.id)
        }
        this.visable = true
        this.visableType = 'FuzzyPeripheral'
      }
      return
    },
    showCompatibleSoftwareInfo(rowData) {
      if (rowData.sourceFrom === 'CUSTOMER_ENV') {
        this.$store.dispatch('SoftwareCompatibleProductRelationByName', {
          softwareName: rowData.softwareName
        })
      } else if (rowData.sourceFrom === 'MANUALLY_ADD') {
        this.$store.dispatch('SoftwareCompatibleProductRelationById', {
          softwareId: rowData.softwareId
        })
      }
    },
    checkIsHavVdiTerminal() {
      this.haveVDITerminal = false
    },
    selectable(row, index) {
      return true
    },
    handleCheckAllPeripheral(val) {
      if (val == true) {
        this.peripheralList.forEach(item => {
          this.$set(item, 'hasOutputTestPlan', true)
        })
      } else {
        this.peripheralList.forEach(item => {
          this.$set(item, 'hasOutputTestPlan', false)
        })
      }
      this.calcSelectPeriCont()
      this.reloadPeripheralSelectTable()
    },
    handleCheckAllSoftware(val) {
      this.softwareNotAllChecked = false
      if (val == true) {
        this.softwareList.forEach(item => {
          this.$set(item, 'hasOutputTestPlan', true)
        })
      } else {
        this.softwareList.forEach(item => {
          this.$set(item, 'hasOutputTestPlan', false)
        })
      }
      this.calcSelectSoftWareCont()
      this.reloadSoftwareSelectTable()
    },
    handleChange(configCpuId) {
      this.selectCalcServer.specServerConfigDTOList.forEach(item => {
        if (item.id === configCpuId) {
          this.selectCalcServer.select = item
        }
      })
      // this.calcServerSetting()
    },
    //用于统一表单数据封闭，被保存，下一步及暂存使用
    getTempData() {
      //去重
      this.imageSystem = this.imageSystem ? [...new Set(this.imageSystem)] : []
      this.appSystem = this.appSystem ? [...new Set(this.appSystem)] : []
      this.hostSystem = this.hostSystem ? [...new Set(this.hostSystem)] : []
      this.supportImageSystem = this.supportImageSystem ? [...new Set(this.supportImageSystem)] : []
      this.supportAppSystem = this.supportAppSystem ? [...new Set(this.supportAppSystem)] : []
      this.supportHostSystem = this.supportHostSystem ? [...new Set(this.supportHostSystem)] : []
      var save_req = {
        network: this.network,
        imageOsTypeIdArr: this.imageSystem,
        appOsTypeIdArr: this.appSystem,
        hostOsTypeIdArr: this.hostSystem,
        supportImageOsTypeIdArr: this.supportImageSystem,
        supportAppOsTypeIdArr: this.supportAppSystem,
        supportHostOsTypeIdArr: this.supportHostSystem,
        peripheralList: this.peripheralList,
        softwareList: this.softwareList,
        terminalList: [],
        thirdTerminalList: [],
        serverCalc: this.calcSetting,
        thirdServerList: [],
        serverList: [],
        productIds: this.productIds
      }

      for (const iterator of this.terminalList) {
        if (iterator.sourceType === 'ThrideTerminal') {
          var changeDTO = this.change2TerminalDtoToThrideTerminalDto(iterator)
          save_req.thirdTerminalList.push(changeDTO)
        } else {
          save_req.terminalList.push(iterator)
        }
      }
      for (const iterator of this.serverList) {
        if ('ThrideServer' === iterator.sourceType) {
          save_req.thirdServerList.push(iterator)
        } else {
          save_req.serverList.push(iterator)
        }
      }

      save_req.network.projectId = this.projectId
      var aaa = JSON.parse(JSON.stringify(save_req))
      return aaa
    },
    changeTempToSimple(dataSou) {
      var data = {}
      data.network = dataSou.network
      data.imageOsTypeIdArr = dataSou.imageOsTypeIdArr
      data.hostOsTypeIdArr = dataSou.hostOsTypeIdArr
      data.appOsTypeIdArr = dataSou.appOsTypeIdArr
      if (dataSou.terminalList) {
        data.terminalList = []
        for (const iterator of dataSou.terminalList) {
          var tmp2 = {
            id: iterator.id,
            hasOutputTestPlan: iterator.hasOutputTestPlan
          }
          data.terminalList.push(tmp2)
        }
      }

      if (dataSou.thirdTerminalList) {
        data.thirdTerminalList = []
        for (const iterator of dataSou.thirdTerminalList) {
          var tmp5 = {
            model: iterator.model,
            hasOutputTestPlan: iterator.hasOutputTestPlan
          }
          data.thirdTerminalList.push(tmp5)
        }
      }

      if (dataSou.softwareList) {
        data.softwareList = []
        for (const iterator of dataSou.softwareList) {
          var tmp1 = {
            id: iterator.id,
            hasOutputTestPlan: iterator.hasOutputTestPlan
          }
          data.softwareList.push(tmp1)
        }
      }
      if (dataSou.peripheralList) {
        data.peripheralList = []
        for (const iterator of dataSou.peripheralList) {
          var tmp0 = {
            id: iterator.id,
            hasOutputTestPlan: iterator.hasOutputTestPlan
          }
          data.peripheralList.push(tmp0)
        }
      }
      if (dataSou.thirdServerList) {
        data.thirdServerList = []
        for (const iterator of dataSou.thirdServerList) {
          var tmp = {
            id: iterator.id,
            hasOutputTestPlan: iterator.hasOutputTestPlan,
            select: iterator.select
          }
          data.thirdServerList.push(tmp)
        }
      }

      if (dataSou.serverList) {
        data.serverList = []
        for (const iterator of dataSou.serverList) {
          var tmp_a = {
            id: iterator.id,
            hasOutputTestPlan: iterator.hasOutputTestPlan,
            cpuConfigId: iterator.cpuConfigId,
            gpuConfigId: iterator.gpuConfigId,
            serverCount: iterator.serverCount
          }
          data.serverList.push(tmp_a)
        }
      }
      var aaa = JSON.parse(JSON.stringify(data))
      return aaa
    },
    //表单暂存统一方法，给全局调用
    getData() {
      var save_req = this.getTempData()
      var save_req_simp = this.changeTempToSimple(save_req)
      var tempData_simp = this.changeTempToSimple(this.tempData)

      var equal = isDeepEqual(tempData_simp, save_req_simp)
      if (equal) {
        return {
          dataChange: false
        }
      } else {
        this.tempData = save_req
        return {
          dataChange: true,
          busDATA: save_req
        }
      }
    },
    //保存变更按钮功能
    async saveStep() {
      var isSelectedTerminal = false
      this.terminalList?.forEach(item => {
        if (item.hasOutputTestPlan) {
          isSelectedTerminal = true
        }
      })
      if (!isSelectedTerminal) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一种终端', type: 'error' })
        return
      }
      if (this.imageSystem.length == 0 && this.hostSystem.length == 0 && this.appSystem.length == 0) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一种类型的操作系统', type: 'error' })
        return
      }

      var save_req = {
        projectId: this.projectId,
        flowStep: 'MDR_PROJECT_ENV',
        network: this.network,
        imageOsTypeIdArr: this.imageSystem,
        appOsTypeIdArr: this.appSystem,
        hostOsTypeIdArr: this.hostSystem,
        peripheralList: this.peripheralList,
        softwareList: this.softwareList,
        terminalList: [],
        thirdTerminalList: [],
        serverCalc: this.calcSetting,
        thirdServerList: [],
        ruijieServerList: [],
        productIds: this.productIds
      }

      if (this.selectTerminalCont === 0) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一款终端', type: 'error' })
        return
      }

      if (this.selectServerCont === 0) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一种服务器', type: 'error' })
        return
      }

      for (const iterator of this.terminalList) {
        if (iterator.sourceType === 'ThrideTerminal') {
          var changeDTO = this.change2TerminalDtoToThrideTerminalDto(iterator)
          save_req.thirdTerminalList.push(changeDTO)
        } else {
          save_req.terminalList.push(iterator)
        }
      }

      for (const iterator of this.serverList) {
        if (iterator.hasOutputTestPlan && iterator.sourceType === 'ThrideServer') {
          iterator.minServerCount = iterator.serverCount
          iterator.diskSize = this.calcSetting.oneDisk * 1000
          save_req.thirdServerList.push(iterator)
        } else if (iterator.hasOutputTestPlan && iterator.sourceType === 'ruijieServer') {
          iterator.minServerCount = iterator.serverCount
          iterator.diskSize = this.calcSetting.oneDisk * 1000
          save_req.ruijieServerList.push(iterator)
        }
      }
      save_req.network.projectId = this.projectId
      this.terminalList.forEach(item => {
        item.projectId = this.projectId
      })
      var result = false
      await updateSceneRealtionEnv(save_req)
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            result = true
            this.getInitDat()
          }
        })
        .catch(e => {
          result = false
        })
      this.$emit('showBtns', {
        preStep: false,
        nextStep: true,
        saveStep: false,
        enableTabChange: true
      })
      return result
    },
    async gotoNextPreVliate() {
      return true
    },
    //下一步按钮功能
    async gotoNextStep() {
      this.message = '点击了下一步'
      var isSelectedTerminal = false
      this.terminalList.forEach(item => {
        if (item.hasOutputTestPlan) {
          isSelectedTerminal = true
        }
      })
      if (!isSelectedTerminal) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一种终端', type: 'error' })
        return
      }
      if (this.imageSystem.length == 0 && this.hostSystem.length == 0 && this.appSystem.length == 0) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一种类型的操作系统', type: 'error' })
        return
      }
      var save_req = {
        projectId: this.projectId,
        flowStep: 'MDR_PROJECT_ENV',
        network: this.network,
        imageOsTypeIdArr: this.imageSystem,
        appOsTypeIdArr: this.appSystem,
        hostOsTypeIdArr: this.hostSystem,
        peripheralList: this.peripheralList,
        softwareList: this.softwareList,
        terminalList: [],
        thirdTerminalList: [],
        serverCalc: this.calcSetting,
        thirdServerList: [],
        ruijieServerList: [],
        productIds: this.productIds
      }
      if (this.selectTerminalCont === 0) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一款终端', type: 'error' })
        return
      }
      if (this.selectServerCont === 0) {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一种服务器', type: 'error' })
        return
      }

      for (const iterator of this.terminalList) {
        if (iterator.sourceType === 'ThrideTerminal') {
          var changeDTO = this.change2TerminalDtoToThrideTerminalDto(iterator)
          save_req.thirdTerminalList.push(changeDTO)
        } else {
          save_req.terminalList.push(iterator)
        }
      }

      for (const iterator of this.serverList) {
        if (iterator.hasOutputTestPlan && iterator.sourceType === 'ThrideServer') {
          iterator.minServerCount = iterator.serverCount
          iterator.diskSize = this.calcSetting.oneDisk * 1000
          save_req.thirdServerList.push(iterator)
        } else if (iterator.hasOutputTestPlan && iterator.sourceType === 'ruijieServer') {
          iterator.minServerCount = iterator.serverCount
          iterator.diskSize = this.calcSetting.oneDisk * 1000
          save_req.ruijieServerList.push(iterator)
        }
      }

      save_req.network.projectId = this.projectId
      this.terminalList.forEach(item => {
        item.projectId = this.projectId
      })
      var result = false
      await updateSceneRealtionEnv(save_req)
        .then(res => {
          result = true
        })
        .catch(e => {
          result = false
        })
      if (!result) {
        return
      }
      await createTestCase({ projectId: this.projectId })
        .then(res => {
          result = true
        })
        .catch(e => {
          result = false
        })
      if (!result) {
        return
      }
      return result
    },
    async queryGlobalData() {
      getAllOsType().then(res => {
        this.osTypeArr = res.data.content.itemArr
        this.osTypeMap = {}
        for (let i = 0; i < this.osTypeArr.length; i++) {
          this.osTypeMap[this.osTypeArr[i].id] = this.osTypeArr[i]
        }
      })
      getNetworkSpeed().then(res => {
        this.networkSpeed = res.data.content.itemArr
      })
      getCalculatorScene().then(res => {
        this.calculatorScene = res.data.content.itemArr
        for (const iterator of this.calculatorScene) {
          this.calculatorSceneMap[iterator.id] = iterator
        }
      })
      getBackupType().then(res => {
        this.backupTypeArr = res.data.content.itemArr
      })
      await sceneBindDetail({ id: this.projectId }).then(res => {
        this.scenes = res.data.content.sceneCollect
        this.scenes.forEach(item => {
          this.sceneMap[item.sceneId] = item
        })
      })
    },
    change2TerminalDtoToThrideTerminalDto(terminalDto) {
      terminalDto.cpu = terminalDto.cpuInfo
      terminalDto.memory = terminalDto.memoryInfo
      terminalDto.diskSize = terminalDto.diskInfo
      return terminalDto
    },
    change2ThrideTerminalDt0ToTerminalDto(terminalDto) {
      terminalDto.cpuInfo = terminalDto.cpu
      terminalDto.memoryInfo = terminalDto.memory
      terminalDto.diskInfo = terminalDto.diskSize
      terminalDto.type = 'THIRD_TERMINAL'
      terminalDto.sourceType = 'ThrideTerminal'
      terminalDto.typeDesc = '第三方终端'
      return terminalDto
    },
    getInitDat() {
      this.loading = true
      getEnvDetail({ projectId: this.projectId }).then(res => {
        this.envData = res.data.content
        if (res.data.content.network) {
          this.network = res.data.content.network
        }
        if (res.data.content.productIds) {
          this.productIds = res.data.content.productIds
        }
        if (res.data.content.imageOsTypeIdArr) {
          this.imageOsTypeIdArr = res.data.content.imageOsTypeIdArr
        }
        if (res.data.content.appOsTypeIdArr) {
          this.appOsTypeIdArr = res.data.content.appOsTypeIdArr
        }
        if (res.data.content.peripheralList) {
          this.peripheralList = res.data.content.peripheralList
        }
        this.calcSelectPeriCont()
        this.reloadPeripheralSelectTable()

        this.terminalList = []
        if (res.data.content.thirdTerminalList) {
          for (const iterator of res.data.content.thirdTerminalList) {
            var changeDto = this.change2ThrideTerminalDt0ToTerminalDto(iterator)
            this.terminalList.push(changeDto)
          }
        }
        if (res.data.content.terminalList) {
          for (const iterator of res.data.content.terminalList) {
            this.terminalList.push(iterator)
          }
        }

        this.calcSelectTerminalCont()

        var idvArr = this.terminalList.filter(item => {
          item.isDisabled = item.hasOutputTestPlan
          return item.hasOutputTestPlan && item.type === 'VDI'
        })
        this.serverList = []
        if (res.data.content.serverList) {
          for (const iterator of res.data.content.serverList) {
            if (idvArr.length > 0 && iterator.type === 'IDV') {
              iterator.enableSelect = false
            } else {
              iterator.enableSelect = true
            }
            iterator.sourceType = 'ruijieServer'
            getServerDetail({ id: iterator.serverId, severConfigKey: 'CPU' }).then(res => {
              iterator.specServerConfigDTOList = res.data.content.specServerConfigDTOList
              iterator.select = res.data.content.specServerConfigDTOList[0]
            })
            getServerDetail({ id: iterator.serverId, severConfigKey: 'GPU' }).then(res => {
              iterator.gpuConfigDTOList = res.data.content.specServerConfigDTOList
            })
            this.serverList.push(iterator)
          }
        }
        if (res.data.content.thirdServerList) {
          for (const iterator of res.data.content.thirdServerList) {
            iterator.enableSelect = true
            iterator.cpuInfo = iterator.cpuTotalThreads
            iterator.memoryInfo = iterator.memory
            iterator.sourceType = 'ThrideServer'
            this.serverList.push(iterator)
          }
        }

        if (res.data.content.serverCalc) {
          this.calcSetting = res.data.content.serverCalc
        }

        if (res.data.content.softwareList) {
          this.softwareList = res.data.content.softwareList
        }
        this.reloadSoftwareSelectTable()
        this.calcSelectSoftWareCont()
        this.reloadServerSelect()
        this.osType.desktop = []
        this.osType.host = []
        this.osType.app = []

        if (res.data.content.imageOsTypeIdArr) {
          this.imageSystem = res.data.content.imageOsTypeIdArr
          this.supportImageSystem = res.data.content.supportImageOsTypeIdArr
          for (const element of this.imageSystem) {
            var aa = this.osTypeMap[element]
            this.osType.desktop.push(aa)
          }
          //先处理云桌面系统，云应用与云主机后期版本看需求开发，后端已经实现对其它两种系统的过滤判断
          this.imageSystem = this.supportImageSystem
        }
        if (res.data.content.appOsTypeIdArr) {
          this.appSystem = res.data.content.appOsTypeIdArr
          this.supportAppSystem = res.data.content.supportAppOsTypeIdArr
          for (const element of this.appSystem) {
            this.osType.app.push(this.osTypeMap[element])
          }
        }
        if (res.data.content.hostOsTypeIdArr) {
          this.hostSystem = res.data.content.hostOsTypeIdArr
          this.supportHostSystem = res.data.content.supportHostOsTypeIdArr
          for (const element of this.hostSystem) {
            this.osType.host.push(this.osTypeMap[element])
          }
        }

        this.$nextTick(() => {
          for (const iterator of this.terminalList) {
            if (iterator.hasOutputTestPlan) {
              this.$refs.terminal_rl_poc.toggleRowSelection(iterator)
            }
          }
          this.checkIsHavVdiTerminal()
        })
        if (res.data.content.thirdServerList) {
          this.thirdServerList = res.data.content.thirdServerList
        }
        this.tempData = this.getTempData()
        this.oldData = this.getTempData()
        this.loading = false
      })
    },
    calcSelectTerminalCont() {
      var selectTrr = this.terminalList.filter(item => {
        return item.hasOutputTestPlan
      })
      this.selectTerminalCont = selectTrr.length
    },
    calcSelectSoftWareCont() {
      var selectArr = this.softwareList.filter(item => {
        return item.hasOutputTestPlan
      })
      this.selectSoftwareCont = selectArr.length
      if (this.selectSoftwareCont === 0) {
        this.$set(this, 'softwareAllChecked', false)
        this.$set(this, 'softwareNotAllChecked', false)
        return
      }
      if (this.selectSoftwareCont !== this.softwareList.length) {
        this.$set(this, 'softwareNotAllChecked', true)
      } else {
        this.$set(this, 'softwareAllChecked', true)
        this.$set(this, 'softwareNotAllChecked', false)
      }
    },
    calcSelectPeriCont() {
      var selectArr = this.peripheralList.filter(item => {
        return item.hasOutputTestPlan
      })
      this.selectPeripheralCont = selectArr.length
      if (this.selectPeripheralCont === 0) {
        this.$set(this, 'peripheralAllChecked', false)
        this.$set(this, 'peripheralNotAllChecked', false)
        return
      }
      if (this.selectPeripheralCont !== this.peripheralList.length) {
        this.$set(this, 'peripheralNotAllChecked', true)
      } else {
        this.$set(this, 'peripheralAllChecked', true)
        this.$set(this, 'peripheralNotAllChecked', false)
      }
    },
    removeSoftware(item, index) {
      this.softwareList.splice(index, 1)
      this.reloadSoftwareSelectTable()
      this.validateDataChange()
    },
    removePeripheral(item, index) {
      this.peripheralList.splice(index, 1)
      this.reloadPeripheralSelectTable()
      this.validateDataChange()
    },
    selectTerminalEnable(row, rowIndex) {
      if (row.type !== 'VDI') {
        return false
      } else {
        return true
      }
    },
    unSelect() {
      this.visableType = null
      this.visable = false
    },
    removeServer(row, index) {
      this.serverList.splice(index, 1)
      if (row.hasOutputTestPlan) {
        this.selectCalcServer = null
      }
    },
    removeTerminal(row, index) {
      this.terminalList.splice(index, 1)
      this.calcSelectTerminalCont()
    },
    addSelectOs(params) {
      if (params.subType === 'DESKTOP') {
        for (const iterator of params.select) {
          const exists = this.osType.desktop.some(obj => obj.id === iterator.osTypeId)
          if (!exists) {
            this.osType.desktop.splice(0, 0, { id: iterator.osTypeId, osType: iterator.osType })
            const existsId = this.imageSystem.some(obj => obj === iterator.osTypeId)
            if (!existsId) {
              this.imageSystem.push(iterator.osTypeId)
            }
          }
          const existsSp = this.supportImageSystem.some(id => id === iterator.osTypeId)
          if (!existsSp) {
            this.supportImageSystem.push(iterator.osTypeId)
          }
        }
      }
      if (params.subType === 'HOST') {
        for (const iterator of params.select) {
          const exists = this.osType.host.some(obj => obj.id === iterator.osTypeId)
          if (!exists) {
            this.osType.host.splice(0, 0, { id: iterator.osTypeId, osType: iterator.osType })
            const existsId = this.hostSystem.some(obj => obj === iterator.osTypeId)
            if (!existsId) {
              this.hostSystem.push(iterator.osTypeId)
            }
          }
          const existsSp = this.supportAppSystem.some(id => id === iterator.osTypeId)
          if (!existsSp) {
            this.supportAppSystem.push(iterator.osTypeId)
          }
        }
      }
      if (params.subType === 'APP') {
        for (const iterator of params.select) {
          const exists = this.osType.app.some(obj => obj.id === iterator.osTypeId)
          if (!exists) {
            this.osType.app.splice(0, 0, { id: iterator.osTypeId, osType: iterator.osType })
            const existsId = this.appSystem.some(obj => obj === iterator.osTypeId)
            if (!existsId) {
              this.appSystem.push(iterator.osTypeId)
            }
          }
          const existsSp = this.supportHostSystem.some(id => id === iterator.osTypeId)
          if (!existsSp) {
            this.supportHostSystem.push(iterator.osTypeId)
          }
        }
      }
      this.validateDataChange()
      this.closerDrawer()
    },
    addSelect(params) {
      if (params.type === 'Peripheral') {
        for (const iterator of params.select) {
          const exists = this.peripheralList.some(
            obj => obj.peripheralId === iterator.id && obj.sceneId === params.sceneId
          )
          if (exists) {
            this.visable = false
            continue
          }
          this.peripheralList.splice(0, 0, {
            description: null,
            hardwareCode: iterator.hardwareCode,
            hasMatched: false,
            hasOutputTestPlan: true,
            interfaceType: iterator.interfaceType,
            manufacturer: iterator.manufacturer,
            compat: iterator.compat,
            name: iterator.name,
            peripheralId: iterator.id,
            sceneId: params.sceneId,
            sceneName: this.sceneMap[params.sceneId].sceneName,
            hasCompatible: false,
            sourceFrom: 'MANUALLY_ADD',
            specPeripheralId: null,
            type: iterator.type,
            typeCN: iterator.typeCN
          })
        }
        this.calcSelectPeriCont()
        this.reloadPeripheralSelectTable()
      }
      if (params.type === 'Software') {
        for (const iterator of params.select) {
          const exists = this.softwareList.some(obj => obj.softwareId === iterator.id && obj.sceneId === params.sceneId)
          if (exists) {
            this.visable = false
            continue
          }
          this.softwareList.splice(0, 0, {
            hasMatched: false,
            hasOutputTestPlan: true,
            sceneId: params.sceneId,
            sceneName: this.sceneMap[params.sceneId].sceneName,
            softwareId: iterator.id,
            compat: iterator.compat,
            hasCompatible: false,
            softwareName: iterator.softwareName,
            softwareVersion: iterator.softwareVersion,
            sourceFrom: 'MANUALLY_ADD',
            specSoftwareId: iterator.id
          })
        }
        this.calcSelectSoftWareCont()
        this.reloadSoftwareSelectTable()
      }
      if (params.type === 'BlackSoftware') {
        for (const iterator of params.select) {
          const exists = this.softwareList.some(
            obj => obj.softwareId === iterator.softwareId && obj.sceneId === iterator.sceneId
          )
          if (exists) {
            this.visable = false
            continue
          }
          iterator.hasOutputTestPlan = true
          iterator.sourceFrom = 'CUSTOMER_ENV'
          this.softwareList.splice(0, 0, iterator)
        }
        this.calcSelectSoftWareCont()
        this.reloadSoftwareSelectTable()
      }
      if (params.type === 'Software') {
        for (const iterator of params.select) {
          const exists = this.softwareList.some(obj => obj.softwareId === iterator.id && obj.sceneId === params.sceneId)
          if (exists) {
            this.visable = false
            continue
          }
          this.softwareList.splice(0, 0, {
            hasMatched: false,
            hasOutputTestPlan: true,
            sceneId: params.sceneId,
            sceneName: this.sceneMap[params.sceneId].sceneName,
            softwareId: iterator.id,
            compat: iterator.compat,
            hasCompatible: false,
            softwareName: iterator.softwareName,
            softwareVersion: iterator.softwareVersion,
            sourceFrom: 'MANUALLY_ADD',
            specSoftwareId: null
          })
        }
        this.calcSelectSoftWareCont()
      }
      if (params.type === 'ThrideTerminal') {
        const exists = this.terminalList.some(
          obj => obj.serverName === params.select.serverName && obj.sourceType === 'ThrideServer'
        )
        if (exists) {
          this.visable = false
          return
        }

        params.select.cpuInfo = params.select.cpu
        params.select.count = 1
        params.select.hasOutputTestPlan = true
        params.select.sceneName = this.sceneMap[params.sceneId].sceneName
        params.select.memoryInfo = params.select.memory
        params.select.diskInfo = params.select.diskSize
        params.select.sourceFrom = 'MANUALLY_ADD'
        params.select.calculatorScene = 'COMMON_MIDDLE'
        params.select.type = 'THIRD_TERMINAL'
        params.select.typeDesc = '第三方终端'
        params.select.sourceType = 'ThrideTerminal'

        this.terminalList.splice(0, 0, params.select)
        this.autoSelectThrideTerminal()
      }

      if (params.type === 'Terminal') {
        var addTerminalList = []
        for (const iterator of params.select) {
          const exists = this.terminalList.some(obj => obj.terminalId === iterator.id && obj.sceneId === params.sceneId)
          if (exists) {
            continue
          }

          var item = {
            count: 1,
            cpuInfo: iterator.cpu,
            hasOutputTestPlan: true,
            cpuCore: iterator.cpuCore,
            diskInfo: iterator.diskSize,
            manufacturer: iterator.manufacturer,
            memoryInfo: iterator.memory,
            model: iterator.model,
            sceneId: params.sceneId,
            sceneName: this.sceneMap[params.sceneId].sceneName,
            sourceFrom: 'MANUALLY_ADD',
            calculatorScene: 'COMMON_MIDDLE',
            terminalId: iterator.id,
            type: iterator.type,
            typeDesc: iterator.typeDesc,
            remarks: iterator.remarks
          }
          this.terminalList.splice(0, 0, item)
          addTerminalList.push(item)
        }
        this.visable = false
        this.$nextTick(() => {
          for (const iterator of this.terminalList) {
            const exists = addTerminalList.some(obj => obj.terminalId === iterator.terminalId)
            if (iterator.hasOutputTestPlan && exists) {
              this.$refs.terminal_rl_poc.toggleRowSelection(iterator)

              iterator.calculatorScene = 'COMMON_MIDDLE'
              if (iterator.type === 'VDI') {
                var sceneItem = this.terminalList.filter(item => {
                  return item.sceneId === iterator.sceneId && item.sourceFrom === 'CUSTOMER_ENV' && item.type === 'PC'
                })
                if (sceneItem.length > 0) {
                  iterator.calculatorCpuCore = sceneItem[0].calculatorCpuCore
                  iterator.memory = parseInt(sceneItem[0].memoryInfo)
                  iterator.calculatorMemory = parseInt(sceneItem[0].calculatorMemory)
                  iterator.diskSize = parseInt(sceneItem[0].diskInfo)
                  iterator.calculatorDiskSize = parseInt(sceneItem[0].calculatorDiskSize)
                } else {
                  iterator.cpu = this.calculatorSceneMap[iterator.calculatorScene].extendedFieldOne
                  iterator.memory = this.calculatorSceneMap[iterator.calculatorScene].extendedFieldTwo
                  iterator.diskSize = 1
                }
              } else {
                iterator.cpu = this.calculatorSceneMap[iterator.calculatorScene].extendedFieldOne
                iterator.memory = this.calculatorSceneMap[iterator.calculatorScene].extendedFieldTwo
                iterator.diskSize = 1
              }
            }

            this.calcSelectTerminalCont()
            this.checkIsHavVdiTerminal()
            this.reloadServerTableChangeEnableSelect()
          }
        })
      }
      if (params.type === 'Server') {
        const exists = this.serverList.some(obj => obj.serverId === params.select.id)
        if (exists) {
          this.visable = false
          return
        }
        getServerDetail({ id: params.select.id, severConfigKey: 'CPU' }).then(res => {
          this.$set(this.serverList[0], 'specServerConfigDTOList', res.data.content.specServerConfigDTOList)
          res.data.content.specServerConfigDTOList?.length &&
            this.$set(this.serverList[0], 'cpuConfigId', res.data.content.specServerConfigDTOList[0].id)
        })
        getServerDetail({ id: params.select.id, severConfigKey: 'GPU' }).then(res => {
          this.$set(this.serverList[0], 'gpuConfigDTOList', res.data.content.specServerConfigDTOList)
        })
        this.serverList.splice(0, 0, {
          cpuInfo: params.select.cpu,
          cpuConfigId: params.select.cpuConfigId,
          diskCount: params.select.diskCount,
          diskInfo: params.select.diskInfo,
          memoryInfo: params.select.memory,
          type: params.select.type,
          sceneId: params.sceneId,
          sceneName: this.sceneMap[params.sceneId].sceneName,
          serverCount: 1,
          sourceType: 'ruijieServer',
          serverId: params.select.id,
          serverName: params.select.serverName,
          sourceFrom: 'MANUALLY_ADD',
          hasOutputTestPlan: true
        })
        this.reloadServerTableChangeEnableSelect()
      }
      if (params.type === 'ThrideServer') {
        const exists = this.serverList.some(
          obj => obj.serverName === params.select.serverName && obj.sourceType === 'ThrideServer'
        )
        if (exists) {
          this.visable = false
          return
        }

        this.serverList.splice(0, 0, {
          cpuInfo: params.select.cpuCore,
          memoryInfo: params.select.memory,
          cpu: params.select.cpu,
          cpuFrequency: params.select.cpuFrequency,
          nicsInfo: params.select.nicsInfo,
          diskInfo: params.select.diskSize,
          diskCount: params.select.diskCount,
          diskSize: params.select.diskSize,
          memory: params.select.memory,
          diskConfigList: params.select.diskConfigList,
          serverType: params.select.serverType,
          sourceType: 'ThrideServer',
          sceneId: params.sceneId,
          sceneName: this.sceneMap[params.sceneId].sceneName,
          serverCount: 1,
          serverName: params.select.serverName,
          type: params.select.type,
          cpuTotalThreads: params.select.cpuTotalThreads,
          sourceFrom: 'MANUALLY_ADD',
          compatibleCheck: params.select.compatibleCheck,
          compatibleResult: params.select.compatibleResult,
          compatibleMsg: params.select.compatibleMsg,
          compatibleResultImg: params.select.compatibleResultImg,
          hasOutputTestPlan: true
        })
        this.reloadServerTableChangeEnableSelect()
      }

      this.validateDataChange()
      this.closerDrawer()
    },
    selectSoftwareAll(selection) {
      if (selection.length > 0) {
        for (const iterator of this.softwareList) {
          iterator.hasOutputTestPlan = true
        }
      } else {
        for (const iterator of this.softwareList) {
          iterator.hasOutputTestPlan = false
        }
      }
      this.calcSelectSoftWareCont()
      this.reloadSoftwareSelectTable()

      this.validateDataChange()
    },
    selectSoftware(selectArr, row) {
      const exists = selectArr.some(obj => obj.softwareId === row.softwareId && obj.sceneId === row.sceneId)
      if (exists) {
        row.hasOutputTestPlan = true
      } else {
        row.hasOutputTestPlan = false
      }
      this.calcSelectSoftWareCont()
      this.reloadSoftwareSelectTable()

      this.validateDataChange()
    },
    validateDataChange() {
      var save_req = this.getTempData()
      var save_req_simp = this.changeTempToSimple(save_req)
      var tempData_simp = this.changeTempToSimple(this.oldData)

      var equal = isDeepEqual(tempData_simp, save_req_simp)
      if (!equal) {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: false,
          saveStep: true,
          enableTabChange: true
        })
      } else {
        this.$emit('showBtns', {
          preStep: false,
          nextStep: false,
          saveStep: false,
          enableTabChange: true
        })
      }
    },
    selectPeripheralAll(selection) {
      if (selection.length > 0) {
        for (const iterator of this.peripheralList) {
          iterator.hasOutputTestPlan = true
        }
      } else {
        for (const iterator of this.peripheralList) {
          iterator.hasOutputTestPlan = false
        }
      }
      this.calcSelectPeriCont()

      this.validateDataChange()
    },
    selectPeripheral(selectArr, row) {
      const exists = selectArr.some(obj => obj.peripheralId === row.peripheralId && obj.sceneId === row.sceneId)
      if (exists) {
        row.hasOutputTestPlan = true
      } else {
        row.hasOutputTestPlan = false
      }
      this.calcSelectPeriCont()

      this.validateDataChange()
    },
    reloadSoftwareSelectTable() {
      this.$refs.software_rl_poc.clearSelection()
      for (const iterator of this.softwareList) {
        this.$nextTick(() => {
          if (iterator.hasOutputTestPlan) {
            this.$refs.software_rl_poc.toggleRowSelection(iterator)
          }
        })
      }
    },
    reloadPeripheralSelectTable() {
      this.$refs.peripheral_rl_poc.clearSelection()
      for (const iterator of this.peripheralList) {
        this.$nextTick(() => {
          if (iterator.hasOutputTestPlan) {
            this.$refs.peripheral_rl_poc.toggleRowSelection(iterator)
          }
        })
      }
    },
    gotoPreStep() {
      this.message = '点击了上一步'
    },
    reloadServerSelect() {
      this.selectServerCont = 0
      this.$nextTick(() => {
        this.$refs.scene_rl_server.clearSelection()
        for (const iterator of this.serverList) {
          if (iterator.hasOutputTestPlan) {
            this.selectServerCont = this.selectServerCont + 1
            this.$refs.scene_rl_server.toggleRowSelection(iterator)
          }
        }
      })
    },
    autoSelectThrideTerminal() {
      this.$nextTick(() => {
        for (const iterator of this.terminalList) {
          if (iterator.hasOutputTestPlan) {
            this.$refs.terminal_rl_poc.toggleRowSelection(iterator, true)
          }
        }
      })
    },
    selectAllServer(selectArr) {
      if (selectArr.length > 0) {
        // 处理全部选中的情况
        for (const iterator of this.serverList) {
          iterator.hasOutputTestPlan = true
          if (iterator.sourceType !== 'ThrideServer') {
            if (iterator.specServerConfigDTOList && !iterator.cpuConfigId) {
              iterator.select = iterator.specServerConfigDTOList[0]
              iterator.cpuConfigId = iterator.select.id
            }
          }
        }
      } else {
        // 处理全部不选中的情况
        for (const iterator of this.serverList) {
          iterator.hasOutputTestPlan = false
          iterator.cpuConfigId = null
        }
      }
      this.reloadServerSelect()

      this.validateDataChange()
    },
    selectServer(selectArr, row) {
      if (!row) {
        return
      }
      if (selectArr.length === 0) {
        this.selectCalcServer = []
        for (const iterator of this.serverList) {
          iterator.hasOutputTestPlan = false
        }
      }
      const exists = selectArr.some(obj => obj.serverId === row.serverId && obj.sceneId === row.sceneId)
      if (exists) {
        row.hasOutputTestPlan = true
      } else {
        row.hasOutputTestPlan = false
        row.cpuConfigId = null
      }

      if (row.sourceType !== 'ThrideServer') {
        if (row.specServerConfigDTOList && !row.cpuConfigId) {
          row.select = row.specServerConfigDTOList[0]
          row.cpuConfigId = row.select.id
        }
      }
      this.reloadServerSelect()

      this.validateDataChange()
    },
    handleSelectionAllChange(selection) {
      if (selection.length > 0) {
        this.selectTerminalCont = selection.length
        // TODO 移除计算器，注释代码，不删除，看后续使用
        for (const iterator of selection) {
          const exists = this.selectCalcTerminal.some(
            obj => obj.terminalId === iterator.terminalId && obj.sceneId === iterator.sceneId
          )
          if (!exists) {
            iterator.calculatorScene = 'COMMON_MIDDLE'
            if (iterator.type === 'VDI') {
              var sceneItem = this.terminalList.filter(item => {
                return item.sceneId === iterator.sceneId && item.sourceFrom === 'CUSTOMER_ENV' && item.type === 'PC'
              })
              if (sceneItem.length > 0) {
                iterator.calculatorCpuCore = sceneItem[0].calculatorCpuCore
                iterator.memory = parseInt(sceneItem[0].memoryInfo)
                iterator.calculatorMemory = parseInt(sceneItem[0].calculatorMemory)
                iterator.diskSize = parseInt(sceneItem[0].diskInfo)
                iterator.calculatorDiskSize = parseInt(sceneItem[0].calculatorDiskSize)
              } else {
                iterator.cpu = this.calculatorSceneMap[iterator.calculatorScene].extendedFieldOne
                iterator.memory = this.calculatorSceneMap[iterator.calculatorScene].extendedFieldTwo
                iterator.diskSize = 1
              }
            } else {
              iterator.cpu = this.calculatorSceneMap[iterator.calculatorScene].extendedFieldOne
              iterator.memory = this.calculatorSceneMap[iterator.calculatorScene].extendedFieldTwo
              iterator.diskSize = 1
            }

            iterator.hasOutputTestPlan = true
          }
        }
      } else {
        this.selectTerminalCont = 0
        this.terminalList.array.forEach(element => {
          element.hasOutputTestPlan = true
        })
      }

      this.reloadServerTableChangeEnableSelect()
      this.calcSelectTerminalCont()
      this.checkIsHavVdiTerminal()

      this.validateDataChange()
    },
    selectTerminal(selection, row) {
      const exists = selection.some(obj => obj.terminalId === row.terminalId && obj.sceneId === row.sceneId)
      if (exists) {
        row.hasOutputTestPlan = true
      } else {
        row.hasOutputTestPlan = false
      }

      this.reloadServerTableChangeEnableSelect()
      this.calcSelectTerminalCont()
      this.checkIsHavVdiTerminal()

      this.validateDataChange()
    },
    reloadServerTableChangeEnableSelect() {
      var enableIDVServer = true
      for (const iterator of this.terminalList) {
        if ('VDI' === iterator.type && iterator.hasOutputTestPlan) {
          enableIDVServer = false
          if (this.selectCalcServer?.length) {
            for (let idx = this.selectCalcServer.length - 1; idx >= 0; idx--) {
              let server = this.selectCalcServer[idx]
              if (server.type == 'IDV') {
                this.selectCalcServer.splice(idx, 1)
              }
            }
          }
        }
      }
      this.hasVDITerminal = !enableIDVServer
      if (!enableIDVServer) {
        for (const serverItem of this.serverList) {
          if (serverItem.type === 'IDV') {
            serverItem.enableSelect = false
            serverItem.hasOutputTestPlan = false
          } else {
            serverItem.enableSelect = true
            serverItem.isDisabled = false
          }
        }
      } else {
        for (const serverItem of this.serverList) {
          serverItem.enableSelect = true
        }
      }
      this.reloadTable = !this.reloadTable
      this.reloadServerSelect()
    },
    addEnvItem(type, subType) {
      this.visable = true
      this.visableType = type
      this.subType = subType
    },
    addSceneRelationTerminal() {
      this.visable = true
      this.visableType = true
    },
    cancelDower() {
      this.visable = false
      this.visableType = null
    },
    closerDrawer() {
      this.visable = false
      this.visableType = null
    },
    showTipsQuestion(tipLabel, title) {
      this.visableTips = true
      this.visableExplanation = 'tips.explanation.' + tipLabel
      this.visableQuestion = 'tips.question.' + tipLabel
      this.visableTitle = title
    },
    closerTipsDrawer() {
      this.visableTips = false
    },
    showImg(row) {
      this.dialogImageUrl = null
      this.compatibleResult = row.compatibleResult
      this.compatibleMsg = row.compatibleMsg
      if (row.compatibleResultImg) {
        if (row.compatibleResultImg.includes('data:image')) {
          this.dialogImageUrl = row.compatibleResultImg
        } else {
          this.dialogImageUrl = `data:image/jpg;base64,${row.compatibleResultImg}`
        }
      }
      this.dialogVisible = true
    },
    selectNoServer() {
      var req_data = {
        exactMatchArr: [],
        page: 0,
        limit: 20,
        matchArr: [
          {
            type: 'FUZZY',
            fieldNameArr: ['serverName'],
            value: '无需服务器',
            matchRule: 'FULL'
          }
        ],
        sortArr: [],
        searchKeyword: '无需服务器',
        needForceRefresh: false,
        isAutomaticRefresh: false
      }
      getServerList(req_data).then(res => {
        const listData = res.data.content.itemArr
        if (listData?.length) {
          const params = listData[0]
          const exists = this.serverList.some(obj => obj.serverId === params.id)
          if (exists) {
            this.visable = false
            return
          }
          getServerDetail({ id: params.id, severConfigKey: 'CPU' }).then(res => {
            this.$set(this.serverList[0], 'specServerConfigDTOList', res.data.content.specServerConfigDTOList)
            res.data.content.specServerConfigDTOList?.length &&
              this.$set(this.serverList[0], 'cpuConfigId', res.data.content.specServerConfigDTOList[0].id)
          })
          getServerDetail({ id: params.id, severConfigKey: 'GPU' }).then(res => {
            this.$set(this.serverList[0], 'gpuConfigDTOList', res.data.content.specServerConfigDTOList)
          })
          const selectSceneId = this.scenes[0].sceneId
          this.serverList.splice(0, 0, {
            cpuInfo: params.cpu,
            cpuConfigId: params.cpuConfigId,
            diskCount: params.diskCount,
            diskInfo: params.diskInfo,
            memoryInfo: params.memory,
            type: params.type,
            sceneId: selectSceneId,
            sceneName: this.sceneMap[selectSceneId].sceneName,
            serverCount: 1,
            sourceType: 'ruijieServer',
            serverId: params.id,
            serverName: params.serverName,
            sourceFrom: 'MANUALLY_ADD',
            hasOutputTestPlan: true
          })
          this.reloadServerTableChangeEnableSelect()
          this.validateDataChange()
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(step-view-env-confirm) {
  .el-table::before {
    z-index: inherit;
  }
  height: 100%;
  .drawer-tips {
    padding: 12px 24px;
    .tips-rl-question {
      padding-top: 12px;
      margin-bottom: 12px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
    }
    .drawer-tips-content {
      word-break: break-word;
      white-space: pre-wrap;
      line-height: 24px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
  .sky-step-view-env-confirm-buttom {
    position: relative;
    height: 102px;
    justify-content: right;
    width: 70%;
    float: right;
    bottom: 90px;
    background-color: white;
    z-index: 13;
    box-shadow: 0 0 12px 0 rgb(24 44 108 / 15%);
    .confirm-title {
      line-height: 28px;
      padding: 0 12px;
    }
    .confirm-env-item-select {
      bottom: 23px;
      display: flex;
      height: 72px;
      width: 100%;
      text-align: center;
      .result-tips {
        color: #ec2805;
        font-size: 18px;
        padding: 8px 12px;
      }
      .result-disk {
        width: 15%;
      }
      .result-server {
        width: 20%;
      }
      .result-cpu {
        input {
          border: none !important;
          font-weight: 700;
          color: #df1b1b;
          text-align: center;
        }
      }
      .result-threads {
        width: 15%;
      }
      .result-memory {
        width: 15%;
      }
      .result-node {
        width: 15%;
      }
      .result-node {
        width: 15%;
      }
      .confirm-env-item-select-server {
        padding: 8px 12px;
        font-weight: 700;
        color: #df1b1b;
        min-width: 144px;
      }
      .confirm-env-item-select-values {
        padding: 0 12px;
      }
    }
  }
  .sky-step-view-env-confirm-content {
    height: 100%;
    overflow-y: scroll;
    .group-buttom {
      height: 42px;
    }

    .env-confirm-group {
      .confirm-group-title {
        // border-bottom: 1px solid #ccc;
        margin: 12px 0;
        width: 85%;
        display: flex;
        .confirm-group-title-icon {
          width: 6px;
          line-height: 28px;
          background-color: #0052d9;
        }
        .confirm-group-title-value {
          font-size: 18px;
          line-height: 28px;
          padding-left: 12px;
          // font-style: italic;
          // margin-bottom: 12px;
        }
        .confirm-group-title-tip {
          line-height: 28px;
          padding-left: 12px;
          color: gray;
        }
      }
      .confirm-group-content {
        .confirm-env-item {
          padding-left: 24px;
          margin-bottom: 12px;
          display: flex;
          i {
            cursor: pointer;
          }
          .fixed-footer {
            position: -webkit-sticky; /* 针对Safari浏览器的兼容性 */
            position: sticky;
            bottom: 0; /* 固定到底部 */
            background-color: #333; /* 背景颜色 */
            color: white; /* 文字颜色 */
            padding: 10px;
          }
          .fixed-footer.is-sticky {
            position: fixed; /* 改为固定定位 */
            width: 100%; /* 全宽度 */
          }
          .confirm-env-item-title {
            padding: 6px 0;
            width: 10%;
            text-align: right;
            padding-right: 24px;
          }
          .confirm-env-item-content {
            width: 88%;
            ::-webkit-scrollbar {
              width: 3px;
            }
            ::-webkit-scrollbar-track {
              border-radius: 3px;
            }
            ::-webkit-scrollbar-thumb {
              background-color: #cccccc;
            }
            ::-webkit-scrollbar-thumb:hover {
              background-color: #999999;
            }
            .software-table {
              max-height: 285px;
              overflow: scroll;
            }

            .confirm-env-item-content-software {
              display: flex;
              flex-wrap: wrap;
              max-height: 330px;
              overflow-y: scroll;
              .soft-add {
                display: flex;
                justify-content: center;
                align-items: center;
                .add-icon {
                  font-size: 44px;
                }
              }
              .confirm-env-item-toolbar {
                background-color: rgba(0, 0, 0, 0.02);
                border-left: 1px solid rgba(0, 0, 0, 0.04);
                border-right: 1px solid rgba(0, 0, 0, 0.04);
                border-bottom: 1px solid rgba(0, 0, 0, 0.04);
                height: 42px;
                .toolbar-title {
                  padding-left: 12px;
                  line-height: 42px;
                }
              }
              // .active {
              //   border: 2px solid #13ce66 !important;
              // }
              .active-icon {
                color: #13ce66;
                font-size: 20px;
                float: right;
              }
              .unactive-icon {
                color: #ccc;
                font-size: 20px;
                float: right;
              }
              .confirm-env-item-software {
                width: 19%;
                height: 120px;
                border: 1px solid #ccc;
                padding: 6px;
                margin: 3px;
                cursor: pointer;
                border-radius: 12px;
                .software-name {
                  font-size: 12px;
                  font-weight: 600;
                  display: flex;
                  padding: 3px;
                  justify-content: flex-start;
                  .blur-active {
                    display: block;
                    font-size: 16px;
                    margin-left: auto;
                  }
                  .tag-success {
                    background-color: #bbf3d4;
                  }
                  .tag-info {
                    background-color: #f8e3b4;
                  }
                  .tag-normal {
                    background-color: #bcdbf3;
                  }
                  .software-name-tag {
                    padding: 1px 3px;
                    line-height: 18px;
                    margin: 0 2px;
                  }
                  .software-name-title {
                    width: 25%;
                    text-align: right;
                  }
                  .software-name-value {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 75%;
                  }
                }
                .software-attr {
                  padding: 3px;
                  .attr-item {
                    display: flex;
                    .attr-item-title {
                      width: 25%;
                      text-align: right;
                    }
                    .attr-item-value {
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      width: 75%;
                    }
                  }
                }
              }
            }
          }
          .confirm-env-item-table {
            .el-table::before {
              z-index: inherit;
            }
            .table-content {
              max-height: 226px;
              overflow-y: scroll;
            }
            .table-content-spec {
              .table-value {
                padding: 6px 12px !important;
              }
              .el-table__body-wrapper .full-value-content .cell {
                padding: 0 !important;
                min-height: 33px !important;
                .full-content {
                  width: 100%;
                  height: 100%;
                }
              }
              .el-table__body-wrapper .cell:first {
                padding: 14px !important;
              }
              td {
                padding: 0 !important;
              }
            }
          }
          .confirm-env-item-toolbar {
            background-color: rgba(0, 0, 0, 0.02);
            border-left: 1px solid rgba(0, 0, 0, 0.04);
            border-right: 1px solid rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid rgba(0, 0, 0, 0.04);
            .toolbar-title {
              float: left;
              padding-left: 12px;
              line-height: 42px;
            }
            .toolbar-btn {
              display: flex;
              justify-content: center;
              .handel-btn {
                padding: 12px;
              }
            }
          }
        }
        .confirm-radio-group {
          line-height: 28px;
          padding-top: 5px;
          padding-left: 22px;
          .confirm-env-item-title {
            width: 10%;
            text-align: right;
            padding-right: 24px;
          }
        }
      }
    }
  }
  .el-icon-warning:before {
    padding-right: 5px !important;
  }

  .el-icon-error:before {
    cursor: pointer !important;
  }
}
</style>
